import React from "react";
import classNames from "classnames";
import styles from "./CircleLoader.module.scss";

export interface ICircleLoaderProps {
  mode?: "light" | "dark";
  className?: string;
}

export const CircleLoader: React.FC<ICircleLoaderProps> = ({
  mode,
  className,
}) => {
  let color = "currentColor";

  if (mode && mode === "light") color = "#FFFFFF";
  if (mode && mode === "dark") color = "#979797";
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
        stroke={color}
        strokeOpacity="0.28"
        strokeWidth="2"
      />
      <path
        className={styles.animation}
        d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1Z"
        stroke={color}
        strokeOpacity="0.84"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
